// spec 260509-system-monitor C-patch 1：Widget → Dashboard 跳转助手。
//
// 单一调用点，让 4 段 widget 点击行为一致：
//   1. launchApp('dashboard', { params: { anchor } })：dashboard 没开 → 打开
//      并把 anchor 作为 launch params；已开 → singleton 让 launchApp 聚焦回。
//   2. window.location.hash = '#anchor'：触发已打开 dashboard 的 hashchange，
//      让它滚到新 anchor（参数路径只对首次 mount 生效，需要 hash 兜住运行时
//      切换）。
//
// 为什么两步都要：
//   - launchApp 是 singleton focus，但**不会**更新已有窗口的 params。
//   - hash 改动是免费的（即使 dashboard 还没开，未来开起来时也会读 hash）。
//   - 两步组合 = "先确保 dashboard 在前台，再切到新 anchor"。

import { launchApp } from '@blade/os-sdk';

const DASHBOARD_APP_ID = 'dashboard';

/**
 * 跳到 dashboard 的指定锚点。
 *
 * @param anchor - 不带 ``#`` 的纯 id（如 ``cpu`` / ``model-llm`` /
 *   ``services-llm``）；为空时只聚焦 dashboard 顶部。
 */
export function navigateToDashboard(anchor: string): void {
  const cleaned = anchor.replace(/^#/, '');

  // 即使 dashboard 已打开，也要让 hashchange 至少触发一次（dashboard 监听
  // hashchange → scrollIntoView 到新 anchor）。
  //
  // 真实浏览器：``window.location.hash = newHash`` 自动 fire hashchange；同
  // hash 设值不 fire。jsdom 跨版本行为不一致——为不依赖具体宿主，统一手动
  // dispatch 一次通用 Event（``HashChangeEvent`` 在某些 jsdom 版本下不可
  // 构造）。dashboard 监听器是幂等的（scrollIntoView 多调一次无害）。
  if (cleaned) {
    if (window.location.hash !== `#${cleaned}`) {
      window.location.hash = `#${cleaned}`;
    }
    window.dispatchEvent(new Event('hashchange'));
  }

  // 启动 / 聚焦 dashboard。launchApp 在 singleton 时会 focus 已有窗口。
  launchApp(DASHBOARD_APP_ID, { params: { anchor: cleaned || undefined } });
}
